export default __webpack_public_path__ + "static/media/icon_key.a0bb7a57.svg";